var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJpg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 0C4.11875 0 3.5 0.61875 3.5 1.375V20.625C3.5 21.3813 4.11875 22 4.875 22H18.625C19.3813 22 20 21.3813 20 20.625V5.5L14.5 0H4.875Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 5.5H20L14.5 0V4.125C14.5 4.88125 15.1187 5.5 15.875 5.5Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.625L15.875 5.5H20V9.625Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 17.875C17.25 18.2531 16.9406 18.5625 16.5625 18.5625H1.4375C1.05937 18.5625 0.75 18.2531 0.75 17.875V11C0.75 10.6219 1.05937 10.3125 1.4375 10.3125H16.5625C16.9406 10.3125 17.25 10.6219 17.25 11V17.875Z",
    fill: "#0D5EAF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4739 13.0262C5.4739 12.5642 6.1999 12.5642 6.1999 13.0262V15.1973C6.1999 16.0608 5.7874 16.5833 4.83659 16.5833C4.36909 16.5833 3.97928 16.4561 3.63828 16.0168C3.35778 15.6813 3.88578 15.198 4.17178 15.5493C4.40278 15.8353 4.65028 15.9013 4.89159 15.8903C5.1989 15.8793 5.46909 15.7411 5.47459 15.1973V13.0262H5.4739Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16797 13.026C7.16797 12.8445 7.31097 12.6465 7.54197 12.6465H8.81178C9.52678 12.6465 10.1703 13.125 10.1703 14.0421C10.1703 14.9111 9.52678 15.3951 8.81178 15.3951H7.89397V16.1211C7.89397 16.3631 7.73997 16.4999 7.54197 16.4999C7.36047 16.4999 7.16797 16.3631 7.16797 16.1211V13.026ZM7.89397 13.3388V14.7083H8.81178C9.18028 14.7083 9.47178 14.3831 9.47178 14.0421C9.47178 13.6578 9.18028 13.3388 8.81178 13.3388H7.89397Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0957 16.0774C13.7052 16.4019 13.2267 16.5394 12.7433 16.5394C11.5883 16.5394 10.7695 15.8801 10.7695 14.5711C10.7695 13.4614 11.633 12.5986 12.7922 12.5986C13.2267 12.5986 13.7045 12.7464 14.0455 13.0819C14.3803 13.4113 13.897 13.9008 13.5677 13.6099C13.3642 13.4119 13.0782 13.2634 12.7922 13.2634C12.1273 13.2634 11.4845 13.7963 11.4845 14.5711C11.4845 15.3851 12.0228 15.8801 12.7433 15.8801C13.0782 15.8801 13.3642 15.7804 13.5677 15.6326V14.9568H12.7433C12.2538 14.9568 12.3033 14.2858 12.7433 14.2858H13.8427C14.0462 14.2858 14.2325 14.4398 14.2325 14.6103V15.7811C14.2325 15.8801 14.1892 15.9722 14.0957 16.0774Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5625 18.5625H3.5V19.25H16.5625C16.9406 19.25 17.25 18.9406 17.25 18.5625V17.875C17.25 18.2531 16.9406 18.5625 16.5625 18.5625Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/jpg.b15cf57b73e86f6db77ae83334162d6c.svg";
export { ForwardRef as ReactComponent };